function toAppleMapsUrl(googleMapsUrl: string): string | null {
  const match = googleMapsUrl.match(
    /google\.com\/maps\/search\/([-\d.]+),\s*([-\d.]+)/,
  );
  if (!match) return null;
  return `https://maps.apple.com/?daddr=${match[1]},${match[2]}`;
}

function dynamicallyCreateAnchorAndNavigate(url: string) {
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

  if (isIOS) {
    const targetUrl = toAppleMapsUrl(url) || url;
    window.open(targetUrl, "_blank");
  } else {
    let anchorElement = document.createElement("a");
    anchorElement.href = url;
    anchorElement.target = "_blank";
    document.body.appendChild(anchorElement);
    anchorElement.click();
    document.body.removeChild(anchorElement);
  }
}

export default dynamicallyCreateAnchorAndNavigate;
